import { createContext, useContext } from 'react'

export const ModalContext = createContext<{ titleId: string }>({ titleId: '' })

/**
 * Access the modal's generated `titleId` so custom header markup can be
 * wired to `aria-labelledby` on the dialog. Prefer `<Modal.Header>` when
 * possible; this is an escape hatch for modals with bespoke chrome.
 */
export function useModalTitleId(): string {
  return useContext(ModalContext).titleId
}
